import { loginAsAdmin } from "@app/lib/admin-session";
import { environment } from "@app/relay/relay-environment";
import { useState } from "react";
import { commitMutation, graphql } from "react-relay";

import type { adminLogin_SessionCreateMutation } from "@app/queries/adminLogin_SessionCreateMutation.graphql";

const sessionCreateMutation = graphql`
  mutation adminLogin_SessionCreateMutation($email: String!, $password: String!) {
    adminSessionCreate(email: $email, password: $password) {
      token
      admin {
        email
      }
      errors {
        message
      }
    }
  }
`;

export default function AdminLogin({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    commitMutation<adminLogin_SessionCreateMutation>(environment, {
      mutation: sessionCreateMutation,
      variables: { email: email.trim(), password },
      onCompleted: (response) => {
        setSubmitting(false);
        const token = response.adminSessionCreate?.token;
        if (token) {
          loginAsAdmin(token);
          onLoggedIn();
        } else {
          setError(response.adminSessionCreate?.errors?.[0]?.message ?? "Invalid credentials");
        }
      },
      onError: () => {
        setSubmitting(false);
        setError("Something went wrong. Try again.");
      },
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-4 rounded-lg bg-white p-8 shadow">
        <h1 className="text-center text-lg font-bold text-gray-900">Staff console</h1>
        <input
          type="email"
          autoComplete="off"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="block w-full rounded border border-gray-300 px-3 py-2 text-sm"
        />
        <input
          type="password"
          autoComplete="off"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="block w-full rounded border border-gray-300 px-3 py-2 text-sm"
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={submitting}
          className="w-full rounded bg-gray-900 py-2 font-medium text-white disabled:opacity-50"
        >
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
